import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';

const AccionaTooltip = ({
  status,
  showToolTip,
  label,
  style = {},
  stylel2 = {},
}) => {
  const intl = useIntl();
  return (
    <div style={{ position: 'relative', zIndex: '900', ...style }}>
      <div
        style={{ ...stylel2 }}
        className="tooltipError"
        hidden={!showToolTip || status?.length === 0 || status === undefined}
      >
        <div className="tooltipArrow"></div>
        {status?.map((value, index) => {
          return (
            <p
              key={index}
              id={`p-tool-${label}-${index}`}
              hidden={!showToolTip}
            >
              {intl.formatMessage(value[0], value[1])}
            </p>
          );
        })}
      </div>
    </div>
  );
};

AccionaTooltip.propTypes = {
  status: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
  showToolTip: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  style: PropTypes.object,
  stylel2: PropTypes.object,
};

AccionaTooltip.defaultProps = {
  status: undefined,
  style: {},
  stylel2: {},
};

export default AccionaTooltip;
